import { useSearchParams } from 'react-router-dom';

import { useScrollTop } from '@hivebrite/react-hooks';

import CreateEditLayout from 'hb-react/frontoffice/apps/Forum/components/CreateEditLayout';
import { CATEGORY_URL_PARAM } from 'hb-react/frontoffice/apps/Forum/constants';
import CreateEditForm from 'hb-react/frontoffice/apps/Forum/containers/CreateEditForm';
import { useCreateDiscussion } from 'hb-react/frontoffice/apps/Forum/hooks/queries/useCreateDiscussion';
import { type FormValues } from 'hb-react/frontoffice/apps/Forum/types';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

interface ForumCreateFormProps {
  initialValues: FormValues;
}

const ForumCreateForm = ({ initialValues }: ForumCreateFormProps) => {
  const { currentUser } = useDefaultAppContexts();
  const { topicId } = useTopicContext();
  const { mutate } = useCreateDiscussion();

  useScrollTop();

  const showUserTargetingButton =
    currentUser?.user_targeting?.forum?.authorized || !!topicId;

  return (
    <CreateEditForm
      title={s__('Forum|Create a discussion')}
      initialValues={initialValues}
      mutate={mutate}
      showUserTargetingButton={showUserTargetingButton}
    />
  );
};

const ForumCreate = () => {
  const [searchParams] = useSearchParams();
  const initialCategories = searchParams.getAll(CATEGORY_URL_PARAM);

  const initialValues: FormValues = {
    category_ids: initialCategories.map((elem) => parseInt(elem, 10)) || [],
    content: '',
    storage_attachments: [],
    storage_uploads: [],
    targeted_user_ids: [],
    title: '',
  };

  return (
    <CreateEditLayout>
      <ForumCreateForm initialValues={initialValues} />
    </CreateEditLayout>
  );
};

export default ForumCreate;
